import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default (props) => {
  return (
    <CopyToClipboard {...props}>
      {props.children}
    </CopyToClipboard>
  );
};



// WEBPACK FOOTER //
// ./src/desktop/components/copy-to-clipboard.js